const TOPICS = [
  { name: '#星际穿越2', count: '128万讨论', hot: true },
  { name: '#国产科幻崛起', count: '96万讨论', hot: true },
  { name: '#诺兰电影宇宙', count: '87万讨论', hot: false },
  { name: '#暑期档看什么', count: '73万讨论', hot: true },
  { name: '#恐怖片推荐', count: '65万讨论', hot: false },
  { name: '#奥斯卡获奖影片', count: '58万讨论', hot: false },
  { name: '#日韩影视精选', count: '51万讨论', hot: false },
  { name: '#花生影院更新日志', count: '44万讨论', hot: true },
  { name: '#冷门佳片挖掘', count: '39万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            影迷们正在热烈讨论的电影话题，加入交流发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <div
              key={topic.name}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-secondary-200 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
              {topic.hot && (
                <span className="flex items-center gap-0.5 text-xs text-accent-600">
                  <i className="ri-fire-line"></i>
                  <span>热</span>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}